<template lang="pug">
  div
    v-card(outlined)
      v-card-title.px-4.pb-2
        div.s1.basic800--text {{ $t('select_shipping_zones') }}
      v-card-text.pa-0
        div.c1.primary400--text.mx-4 {{ $t('shipping_zone_options') }}:
        div.mt-4
          template(v-for="(zone, idx) in zones")
            div.d-flex.align-center.py-4.pr-1.pl-4(:key="zone.id")
              div.s1.basic800--text {{ zone.name }}
              v-spacer
              div
                y-switch.mb-n3.mx-0.pa-0(v-model="zone.enabled" @change="updateExcluded(zone)")
            v-divider.basic300
    div.mt-4.py-4.pr-1.pl-4(v-if="orderSettings && showOrderSettingSwitch" :style="`background-color: ${$vuetify.theme.themes[$theme].infoT08}; border-radius: 4px`")
      v-row(no-gutters)
        v-col(cols="7")
          div.p2.info500--text {{ $t('turn_on_local_order') }}
        v-spacer
        v-col.shrink
          y-switch.mb-n3.mx-0.pa-0(v-model="exForm" :color="$vuetify.theme.themes[$theme].info500")
</template>

<script>
export default {
  name: 'FormZonesShipping',
  props: ['company', 'form', 'szones', 'excludedZones', 'parentOrderSettings'],
  data: (v) => ({
    zones: v.szones || [],
    // exZones: [] // Working array
  }),
  mounted () {
    this.zones.forEach(zone => {
      zone.enabled = this.exZones.indexOf(zone.id) === -1
    })
  },
  computed: {
    exZones: {
      get () {
        if (this.excludedZones) {
          return this.excludedZones
        }
        return []
      },
      set(newValue) {
        this.$emit('update:excludedZones', newValue)
      }
    },
    orderSettings: {
      get() {
        return this.parentOrderSettings
      },
      set(newValue) {
        this.$emit('update:parentOrderSettings', newValue)
      }
    },
    exForm: {
      get() {
        if (this.parentOrderSettings && this.parentOrderSettings.excluded_forms && this.parentOrderSettings.excluded_forms.length > 0 && this.parentOrderSettings.excluded_forms.filter(f => f === this.form.id).length > 0) {
          return false
        }
        return true
      },
      set(newValue) {
        if (newValue) {
          this.$set(this.orderSettings, 'excluded_forms', this.orderSettings.excluded_forms.filter(f => f !== this.form.id))
        } else {
          if (this.orderSettings.excluded_forms.filter(f => f === this.form.id).length === 0) {
            this.orderSettings.excluded_forms.push(this.form.id)
          }
        }
      }
    },
    showOrderSettingSwitch () {
      if (this.zones.filter(f => f.fulfilment_type.includes('local_delivery') && f.enabled === true).length > 0) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    exZones: {
      deep: true,
      handler () {
        this.zones.forEach(zone => {
          zone.enabled = this.exZones.indexOf(zone.id) === -1
        })
      }
    }
  },
  methods: {
    updateExcluded(zone) {
      let index = this.exZones.indexOf(zone.id)
      if (zone.enabled && index !== -1) {
        this.exZones.splice(index, 1);
      } else if (!zone.enabled && index === -1) {
        this.exZones.push(zone.id)
      }
    }
  }
}
</script>

<style scoped>
.message {
  white-space: pre-wrap;
}
</style>

<i18n>
{
  "en": {
    "shipping_zone_options": "Shipping zone options at checkout are",
    "turn_on_local_order": "Turn on local order settings for this form"
  },
  "id": {
    "shipping_zone_options": "Zona pengiriman di checkout:",
    "turn_on_local_order": "Aktifkan pengaturan pesanan lokal untuk form ini"
  }
}
</i18n>
